export const homeObjOne = {
  lightBg: false,
  primary: true,
  imgStart: "",
  lightTopLine: true,
  lightText: true,
  buttonLabel: "Get Started",
  description:
    "We provide IT solutions and help business owners increase their revenue. Our team of unique specialists can help you achieve your business goals",
  lightTextDesc: true,
  headLine: "IT Managment - IT Services and Business Generation",
  topLine: "IT & Marketing Agency",
  img: require("../images/travel.svg").default,
  alt: "Image",
  start: "",
};
export const homeObjTwo = {
  lightBg: true,
  primary: false,
  imgStart: "start",
  lightTopLine: false,
  lightText: false,
  buttonLabel: "Get Started",
  description:
    "We provide IT solutions and help business owners increase their revenue. Our team of unique specialists can help you achieve your business goals",
  lightTextDesc: false,
  headLine: "IT Managment - IT Services and Business Generation",
  topLine: "IT & Marketing Agency",
  img: require("../images/engineer.svg").default,
  alt: "Image",
  start: "true",
};
export const homeObjThree = {
  lightBg: false,
  primary: true,
  imgStart: "",
  lightTopLine: true,
  lightText: true,
  buttonLabel: "Get Started",
  description:
    "We provide IT solutions and help business owners increase their revenue. Our team of unique specialists can help you achieve your business goals",
  lightTextDesc: true,
  headLine: "IT Managment - IT Services and Business Generation",
  topLine: "IT & Marketing Agency",
  img: require("../images/s.svg").default,
  alt: "Image",
  start: "",
};
export const homeObjFour = {
  lightBg: false,
  primary: true,
  imgStart: "start",
  lightTopLine: true,
  lightText: true,
  buttonLabel: "Get Started",
  description:
    "We help business owners increase their revenue. Our team of unique specialists can help you achieve your business goals",
  lightTextDesc: true,
  headLine: "Lead Generation Specialist For Online Businesses",
  topLine: "Marketing Agency",
  img: require("../images/engineer.svg").default,
  alt: "Image",
  start: "true",
};
